¬<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-xl border border-gray-700 bg-gradient-to-b from-gray-800 to-gray-900">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
      </div>
      <Navbar />
    </aside>
    
    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Top Navbar -->
      <Header></Header>
      
      <!-- Dashboard Content -->
      <main class="p-6 flex-1">
        <div class="grid grid-cols-3 gap-6">
          <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                      rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold">Welcome, {{ name }}</h3>
          </div>
          <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                      rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold">Active Servers</h3>
            <p class="text-2xl font-bold">{{ activeServers }}</p>
          </div>
          <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                      rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold">Billing</h3>
            <p class="text-2xl font-bold">${{ parseFloat(billingAmount).toFixed(2) }}</p>
            <p class="text-sm text-gray-400">Next due: {{ billingDueDate }}</p>
            <button @click="moveToBilling" class="mt-2 bg-blue-500 px-4 py-2 rounded hover:bg-blue-600 transition">
              Manage Billing
            </button>
          </div>
        </div>
        
        <!-- Billing Details -->
        <div class="mt-8 p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                    rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
          <h3 class="text-lg font-semibold mb-4">Billing Overview</h3>
          <div class="grid grid-cols-2 gap-6">
            <div>
              <h4 class="text-md font-semibold">Recent Invoices</h4>
              <ul class="mt-2 text-sm text-gray-400">
                <li v-for="invoice in invoices" :key="invoice.id">
                  Invoice #{{ invoice.id }} - ${{ invoice.amount }} - {{ invoice.status }}
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-md font-semibold">Payment Methods</h4>
              <ul class="mt-2 text-sm text-gray-400">
                <li v-for="invoice in invoices" :key="invoice.id">
                  Card ending in {{ paymentMethodLast4 }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Navbar from '@/components/nav.vue';
import Header from '@/components/header.vue';

export default {
  name: "CloudDashboard",
  data() {
    return {
      showNotifications: false,
      activeServers: 0,
      billingAmount: 0,
      billingDueDate: "N/A",
      invoices: [],
      paymentMethodLast4: null,
      name: "",
    };
  },
  components: {
    Navbar,
    Header
  },
  methods: {
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
    },
    moveToSettings() {
      this.$router.push(`/settings`);
    },
    moveToBilling() {
      this.$router.push(`/billing`);
    },
    async fetchDashboardData() {
      try {
        const response = await axios.get('https://api.syniac.com:3000/api/dashboard/', { withCredentials: true });
        this.activeServers = response.data.activeServers;
        this.name = response.data.name[0]?.name.split(" ")[0] || "";
        this.billingAmount = response.data.billingAmount;
        this.billingDueDate = response.data.billingDueDate;
        this.invoices = response.data.invoices;
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
    async fetchPaymentInfo() {
      try {
        const response = await axios.get('https://api.syniac.com:3000/api/billing/payment-method', { withCredentials: true });
        if (response.data.success) {
          this.paymentMethodLast4 = response.data.last4; 
        } 
      } catch (error) {
        console.error('Error fetching payment method', error);
      }
    }
  },
  mounted() {
    this.fetchDashboardData();
    this.fetchPaymentInfo();
  },
};
</script>
